<template>
  <div class="scroll-target"></div>
</template>

<script>
  export default {
    name: "ScrollTarget",
    emits: ['scroll-to'],
    mounted() {
      this.$emit('scroll-to', { target: this.$route.path })
    }
  }
</script>

<style scoped>

</style>